
import * as MsitTelemetry from '@microsoftit/telemetry-extensions-npm';

export class SystemEvent extends MsitTelemetry.SystemEvent {
        
	constructor(eventName: string, componentType: MsitTelemetry.ComponentType, systemMessage: string) {
		super(eventName, componentType, systemMessage);
	}
}